export enum MyOrdersAnalyticsMessages {
  capability = 'orders',
  myOrdersPageName = 'us foods:r4:my orders',
  pastOrdersPageName = 'us foods:r4:past orders',
  pageLoadedEvent = 'page loaded',
  modalOpen = 'modal open',
  copyOrder = 'copy order',
  filtersApplied = 'filters applied',
}
